module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container auto homePage2"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "30px 150px"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('el-col', {
      key: item.title,
      attrs: {
        "span": 5
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/img/a' + index + '.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p15"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))])])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("SOLUTION")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "tit_cont"
  }, [_vm._v("\n                专注云打印解决方案，多年互联网应用开发经验，整合时下最新的云打印技术\n                "), _c('br'), _vm._v("以产品设计为核心驱动力，协同专业的项目能力，为客户提供针对性的解决方案，帮助客户解决问题\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6b05124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePage2.vue
// module id = 350
// module chunks = 1